import { SET_FILTER_DATA } from '../actionTypes';
import { attachmentsActions } from '../reducer';

export default (values) => attachmentsActions[SET_FILTER_DATA](values);
